var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-230.000000, -5216.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.000000, 5216.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.875,0 L8.125,0 C3.638375,0 0,3.638375 0,8.125 L0,17.875 C0,22.361625 3.638375,26 8.125,26 L17.875,26 C22.361625,26 26,22.361625 26,17.875 L26,8.125 C26,3.638375 22.361625,0 17.875,0 Z M23.5625,17.875 C23.5625,21.01125 21.01125,23.5625 17.875,23.5625 L8.125,23.5625 C4.98875,23.5625 2.4375,21.01125 2.4375,17.875 L2.4375,8.125 C2.4375,4.98875 4.98875,2.4375 8.125,2.4375 L17.875,2.4375 C21.01125,2.4375 23.5625,4.98875 23.5625,8.125 L23.5625,17.875 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,7 C9.910375,7 7,9.910375 7,13.5 C7,17.089625 9.910375,20 13.5,20 C17.089625,20 20,17.089625 20,13.5 C20,9.910375 17.089625,7 13.5,7 Z M13.5,17.5625 C11.26075,17.5625 9.4375,15.73925 9.4375,13.5 C9.4375,11.259125 11.26075,9.4375 13.5,9.4375 C15.73925,9.4375 17.5625,11.259125 17.5625,13.5 C17.5625,15.73925 15.73925,17.5625 13.5,17.5625 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.5,
    cy: 6.5,
    r: 1.5
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.4cd4cb84.svg";
export { ForwardRef as ReactComponent };